import {InventoryCategory} from './_models'

export type CategoryLookupOption = {
  id: string | number
  label: string
}

/** Normalize inventory-category API payloads (direct array or Axios-shaped). */
export function normalizeInventoryCategoryRows(response: unknown): InventoryCategory[] {
  if (Array.isArray(response)) {
    return response
  }
  if (response && typeof response === 'object') {
    const data = (response as {data?: unknown}).data
    if (Array.isArray(data)) {
      return data
    }
  }
  return []
}

/** Map API categories to SearchableLookupField options (company-wide; id + name only). */
export function toCategoryLookupOptions(
  categories: InventoryCategory[],
): CategoryLookupOption[] {
  return normalizeInventoryCategoryRows(categories)
    .filter((category) => category?.id != null && String(category.name ?? '').trim() !== '')
    .map((category) => ({
      id: category.id,
      label: String(category.name).trim(),
    }))
}
